import { __assign, __generator, __rest } from "tslib";
import React from 'react';
import { put, call } from 'redux-saga/effects';
import { request } from '../../xhr';
import { Warning } from '@wix/da-ds/pkg/Icons/Confirmations';
import { pushGlobalConfirmationModalForMM } from '../../Modals/redux/actionCreators';
import { canMakeDeviationPremium } from '../helpers';
import { DeviationTypes } from '../../types/deviation';
export function checkAndWarnIfDeviationsAreNotSupportedForPremium(deviations) {
    var hasUnsupportedDeviationSelected;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                hasUnsupportedDeviationSelected = deviations.some(function (deviation) { return !canMakeDeviationPremium(deviation); });
                if (!hasUnsupportedDeviationSelected) return [3 /*break*/, 2];
                return [4 /*yield*/, put(pushGlobalConfirmationModalForMM({
                        titleTransKey: 'mediapopup.warningPopup.deviationNotSupportedForPremium.title',
                        textTransKey: 'mediapopup.warningPopup.deviationNotSupportedForPremium.text',
                        confirmBtnLabelTransKey: 'common.ok',
                        withCancelButton: false,
                        confirmBtnType: 'dark',
                        icon: React.createElement(Warning, null),
                    }))];
            case 1:
                _a.sent();
                return [2 /*return*/, true];
            case 2: return [2 /*return*/, false];
        }
    });
}
export function fetch(_a) {
    var response;
    var url = _a.url, params = _a.params, _b = _a.method, method = _b === void 0 ? 'get' : _b, fakeResponse = _a.fakeResponse, otherOptions = __rest(_a, ["url", "params", "method", "fakeResponse"]);
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, call(request, __assign({ url: url, method: method, params: params }, otherOptions), fakeResponse)];
            case 1:
                response = _c.sent();
                return [2 /*return*/, response];
        }
    });
}
export var fakeResponseForType = function (type) {
    return function (_a) {
        var params = _a.params;
        if (process.env.NODE_ENV !== 'production') {
            var deviationsByType = require('@wix/da-sample-data').deviationsByType; // eslint-disable-line global-require
            if (window.doError) {
                return {
                    error: 'invalid_request',
                    error_description: 'Not logged in.',
                    status: 'error',
                };
            }
            var items = void 0;
            switch (type) {
                case 'all_posts':
                    items = deviationsByType.polls;
                    break;
                case DeviationTypes.IMAGE:
                case DeviationTypes.JOURNAL:
                case DeviationTypes.LITERATURE:
                case DeviationTypes.FILM:
                case DeviationTypes.PDF:
                    items = deviationsByType[type];
                    break;
                case DeviationTypes.POLL:
                    items = deviationsByType.polls;
                    break;
                case DeviationTypes.COMMISSION:
                    items = deviationsByType.commissions;
                    break;
                case DeviationTypes.STATUS:
                    items = deviationsByType.statuses;
                    break;
                default:
                    items = [];
            }
            var offset = params.offset, limit = params.limit;
            var randomDeviations = items.slice(offset, offset + limit);
            return {
                hasMore: offset + limit < items.length,
                nextOffset: offset + limit,
                results: randomDeviations,
            };
        }
    };
};
//# sourceMappingURL=helpers.js.map